<div class="tag-legend-widget">
    <kendo-loader *ngIf="isLoading" [type]="'converging-spinner'" [themeColor]="'primary'" [size]="'large'">
    </kendo-loader>

    <div #legendContainer id="legendContainer" [ngClass]="{ 'hidden': error, 'svg-container': true }">
    </div>

    <span *ngIf="error && !isLoading" class="widget-error">{{error}}</span>
</div>